var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-analytics-item"},[_c('router-link',{staticClass:"header-analytics-item__link",attrs:{"to":_vm.headerAnalyticsItem.route}},[_vm._v("\n        "+_vm._s(_vm.headerAnalyticsItem.name)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }